export default __webpack_public_path__ + "static/media/location_preview_s4_drive_to_win.e582abdb.svg";